export enum WorkReportType {
  Patrol = 0,
  ParkWork = 1,
}
